import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Container, Typography, Paper, IconButton, Grid, Divider
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LagbasLogo from '../components/LagbasLogo';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import QrCode2Icon from '@mui/icons-material/QrCode2';

const CARDS = [
  {
    label: 'QR-KodN',
    desc: 'Generera QR-koder med Tikab-logotyp — positiv/negativ, runda kanter, PNG och SVG-export',
    icon: <QrCode2Icon sx={{ fontSize: 36, color: '#FF6B00' }} />,
    path: '/marketing/qrkod',
  },
  {
    label: 'Mailsignatur',
    desc: 'Skapa och exportera signaturer för Outlook Desktop, Web och mobil',
    icon: <AlternateEmailIcon sx={{ fontSize: 36, color: '#FF6B00' }} />,
    path: '/marketing/signature',
  },
  {
    label: 'LinkedIn Verkstad',
    desc: 'Planera, skapa och förhandsgranska LinkedIn-inlägg med AI – inkl. 3-nivå produktdelning och redaktionskalender',
    icon: <LinkedInIcon sx={{ fontSize: 36, color: '#0a66c2' }} />,
    path: '/marketing/linkedin',
  },
  {
    label: 'PitchN',
    desc: 'AI-genererade kundpresentationer med Tikab-design — helskärm eller HDMI-utskjutning',
    icon: <SlideshowIcon sx={{ fontSize: 36, color: '#E05A00' }} />,
    path: '/pitch',
  },
];

export default function Marketing() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box sx={{ bgcolor: '#1a1a1a', color: 'white', py: 1.5, px: 3,
        display: 'flex', alignItems: 'center', gap: 2 }}>
        <LagbasLogo />
        <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(255,255,255,0.2)', mx: -0.5 }} />
        <IconButton color="inherit" size="small" onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">Marknad</Typography>
          <Typography variant="caption" sx={{ color: '#aaa' }}>
            Verktyg för marknad och kommunikation
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Grid container spacing={2}>
          {CARDS.map(card => (
            <Grid item xs={12} sm={6} md={4} key={card.path}>
              <Paper
                onClick={() => navigate(card.path)}
                sx={{ p: 3, cursor: 'pointer', '&:hover': { boxShadow: 4 },
                  transition: 'box-shadow .15s', borderTop: '3px solid #FF6B00' }}>
                <Box sx={{ mb: 1.5 }}>{card.icon}</Box>
                <Typography fontWeight="bold" sx={{ mb: 0.5 }}>{card.label}</Typography>
                <Typography variant="body2" color="text.secondary">{card.desc}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
